import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AuthenticationApiCalls } from "../../apis/AuthenticationApiCalls";
import { YuJaCheckbox } from "../../components/standardization/YuJaCheckbox";
import { YuJaDropdown } from "../../components/standardization/YuJaDropdown";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import useHostname from "../../hooks/useHostname";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import {
  ADFS_LOGIN_OPTION_TITLE, AZURE_LOGIN_OPTION_TITLE,
  CHECKED, DCAM_LOGIN_OPTION_TITLE,
  ENTER_PWD_TEXT,
  ENTER_USERNAME_TEXT,
  FORGOT_ARIA_LABEL,
  FORGOT_PWD_TEXT, GOOGLE_LOGIN_OPTION_TITLE,
  INVALID_PWD_TEXT,
  INVALID_USER_NAME_TEXT,
  JOIN_AS_PARTICIPANT_TEXT,
  JOIN_PARTICIPANT_PATH,
  LOGIN_LOGO_TEXT,
  LOGIN_METHODS,
  PASSWORD,
  PLATFORM_SETTINGS,
  REMEMBER_ME_ARIA_LABEL,
  REMEMBER_ME_TEXT,
  SCREEN_TYPE, SHIBBOLETH_LOGIN_OPTION_TITLE, SHOW_OR_HIDE_PWD_TEXT,
  SIGN_IN_OPTION_LABEL_TEXT,
  SIGN_IN_TEXT,
  SIGN_IN_TO_YOUR_ACCOUNT_TEXT,
  TEXTBOX,
  UNCHECKED,
  USERNAME,
  WELCOME_TO_PLATFORM_TEXT,
  YUJA_DROPDOWN_SIZE, YUJA_LOGIN_OPTION_TITLE
} from "../../utils/constants";
import {checkAllEmpty, newPageLog, notifyError} from "../../utils/helpers";
import useQuery from "../../utils/queryparam";
import {
  EMAIL_MISSING_LOGIN_ERROR_LMS,
  GENERIC_THIRD_PARTY_LOGIN_ERROR,
  GIVEN_NAME_MISSING_LOGIN_ERROR_LMS,
  LAST_NAME_MISSING_LOGIN_ERROR_LMS,
  LOGIN_GENERAL_ERROR,
  THIRD_PARTY_PARAM_MISSING_LOGIN_ERROR
} from "../../utils/toast-message-constants";
import styles from "./Login.module.css";
import EyeClosed from "./images/EyeClosed.svg";
import EyeOpen from "./images/EyeOpen.svg";
import {ReactComponent as INVALID_ICON} from "./images/invalid-icon.svg"
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";

export default function LoginPage() {
  const { login, getSAMLRedirectURL } = AuthenticationApiCalls();
  const hostResource = useHostname(window.location.hostname);
  const {platformSetting, ssoConfig={}, imageURL, fullName, logoImageURL} = hostResource;
  const [,getSession] = useLocalStorageNew("session", {});
  const history = useHistory();
  const location = useLocation();
  const {type} = useWindowDimensions();
  const [keepSignIn, setKeepSignIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  // const [institutionName, setInstitutionName] = useState(YUJA_TITLE);
  const [passwordShown, setPasswordShown] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [setGuestSession, ] = useLocalStorageNew("guestSession", {});

  const SSO_LOGIN_ERROR_MSG_ARR = ["invalidParams", "parseError", "invalidSign", "invalidAssertion","invalidFirstName", "invalidLastName", "invalidEmail"];
  let errorParams = useQuery();
  const convertDefaultName = (name) => {
    if (name === LOGIN_METHODS.YUJA) {
      return YUJA_LOGIN_OPTION_TITLE;
    } else if (name === LOGIN_METHODS.ADFS) {
      return ADFS_LOGIN_OPTION_TITLE;
    } else if (name === LOGIN_METHODS.SHIBBOLETH) {
      return SHIBBOLETH_LOGIN_OPTION_TITLE;
    } else if (name === LOGIN_METHODS.DCAM) {
      return DCAM_LOGIN_OPTION_TITLE;
    } else if (name === LOGIN_METHODS.GOOGLE) {
      return GOOGLE_LOGIN_OPTION_TITLE;
    } else if (name === LOGIN_METHODS.AZURE) {
      return AZURE_LOGIN_OPTION_TITLE;
    }
  }

  const [loginMethodOptions, setLoginMethodOptions] = useState(() => {
    const opts = Object.entries(LOGIN_METHODS).map((entry, index) => {
      return {
        defaultName: convertDefaultName(entry[1]),
        abbr: "",
        key: entry[0],
        val: entry[1],
        no: index + 1,
        enabled: entry[1] === LOGIN_METHODS.YUJA,
        selected: entry[1] === LOGIN_METHODS.YUJA,
      }
    });
    return opts;
  });

  const inlineStyles = {
    rowStyle: {display: "flex", alignItems: "center", columnGap: 5, rowGap: 10, flexWrap: "wrap"},
    inputBoxStyle: {fontSize: 15, height: 47, fontWeight: "400", padding: 12},
    linkStyle: {textDecoration: "underline", fontSize: 16, alignSelf: "center"},
  }

  // This will be triggered when some required params were not passed from the SAML Identity Provider
  // NameID, Given Name, Last Name and Email are mandatory
  useEffect(() => {
    if (errorParams.get("errorMsg")) {
      if (SSO_LOGIN_ERROR_MSG_ARR.includes(errorParams.get("errorMsg"))) {
        if(errorParams.get("errorMsg") === "invalidFirstName") {
          notifyError(GIVEN_NAME_MISSING_LOGIN_ERROR_LMS);  
        } else if(errorParams.get("errorMsg") === "invalidLastName") {
          notifyError(LAST_NAME_MISSING_LOGIN_ERROR_LMS);  
        } else if(errorParams.get("errorMsg") === "invalidEmail") {
          notifyError(EMAIL_MISSING_LOGIN_ERROR_LMS);  
        } else {
          notifyError(THIRD_PARTY_PARAM_MISSING_LOGIN_ERROR);
        }
      } else if(errorParams.get("errorMsg") === "Y021") {
        notifyError(GIVEN_NAME_MISSING_LOGIN_ERROR_LMS);
      } else if(errorParams.get("errorMsg") === "Y022") {
        notifyError(LAST_NAME_MISSING_LOGIN_ERROR_LMS);
      } else if(errorParams.get("errorMsg") === "Y023") {
        notifyError(EMAIL_MISSING_LOGIN_ERROR_LMS);
      } else {
        notifyError(GENERIC_THIRD_PARTY_LOGIN_ERROR);
      }
    }  
  }, []);

  // const isTablet = useMobileAccess(1024);

  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // const handleOptionSelect = (idx) => {
  //   let optsCopy = JSON.parse(JSON.stringify(loginMethodOptions));
  //   optsCopy = optsCopy.map(item => ({...item, selected: false}));
  //   optsCopy[idx].selected = true;
  //   setLoginMethodOptions(optsCopy);
  //   setIsDropdownOpen(false);
  // };

  useEffect(() => {
    if (location.state && location.state.msg) {
      notifyError(location.state.msg);
      const newState = {...location.state};
      delete newState.msg
      window.history.replaceState(newState, document.title)
    }
  }, [location.state]);

  useEffect(() => {
    if (getSession().authorization) {
      history.push({
        pathname: "/home"
      });
      return;
    }

    let optsCopy = JSON.parse(JSON.stringify(loginMethodOptions));
    optsCopy.find(item => item.val === LOGIN_METHODS.ADFS).enabled = ssoConfig.ADFS && !checkAllEmpty(ssoConfig.ADFS);
    optsCopy.find(item => item.val === LOGIN_METHODS.SHIBBOLETH).enabled = ssoConfig.SHIBBOLETH && !checkAllEmpty(ssoConfig.SHIBBOLETH);
    optsCopy.find(item => item.val === LOGIN_METHODS.DCAM).enabled = ssoConfig.DCAM && !checkAllEmpty(ssoConfig.DCAM);
    optsCopy.find(item => item.val === LOGIN_METHODS.GOOGLE).enabled = ssoConfig.GOOGLE && !checkAllEmpty(ssoConfig.GOOGLE);
    optsCopy.find(item => item.val === LOGIN_METHODS.AZURE).enabled = ssoConfig.AZURE && !checkAllEmpty(ssoConfig.AZURE);

    if (!platformSetting) {
      return
    }
    //set default login method
    optsCopy = optsCopy.map(item => ({...item, selected: false}));
    if (!!platformSetting[PLATFORM_SETTINGS.DEFAULT]) {
      const no = parseInt(platformSetting[PLATFORM_SETTINGS.DEFAULT])
      optsCopy.find((item => item.no === no)).selected = true
    }

    //check if needs to disable YuJa login
    if (!!platformSetting[PLATFORM_SETTINGS.YUJA_LOGIN]) {
      optsCopy.find(item => item.val === LOGIN_METHODS.YUJA).enabled = platformSetting[PLATFORM_SETTINGS.YUJA_LOGIN] !== "true";
    }
    if (!optsCopy.find(item => item.val === LOGIN_METHODS.YUJA).enabled) {
      optsCopy.find(item => item.val === LOGIN_METHODS.YUJA).selected = false;
    }


    //check if needs to update the login method name
    if (!!platformSetting[PLATFORM_SETTINGS.YUJA_NAME] && platformSetting[PLATFORM_SETTINGS.YUJA_NAME].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.YUJA).abbr = platformSetting[PLATFORM_SETTINGS.YUJA_NAME];
    }
    if (!!platformSetting[PLATFORM_SETTINGS.SSONAME_ADFS] && platformSetting[PLATFORM_SETTINGS.SSONAME_ADFS].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.ADFS).abbr = platformSetting[PLATFORM_SETTINGS.SSONAME_ADFS];
    }
    if (!!platformSetting[PLATFORM_SETTINGS.SSONAME_SHI] && platformSetting[PLATFORM_SETTINGS.SSONAME_SHI].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.SHIBBOLETH).abbr = platformSetting[PLATFORM_SETTINGS.SSONAME_SHI];
    }
    if (!!platformSetting[PLATFORM_SETTINGS.SSONAME_DCAM] && platformSetting[PLATFORM_SETTINGS.SSONAME_DCAM].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.DCAM).abbr = platformSetting[PLATFORM_SETTINGS.SSONAME_DCAM];
    }
    if (!!platformSetting[PLATFORM_SETTINGS.SSONAME_GOOGLE] && platformSetting[PLATFORM_SETTINGS.SSONAME_GOOGLE].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.GOOGLE).abbr = platformSetting[PLATFORM_SETTINGS.SSONAME_GOOGLE];
    }
    if (!!platformSetting[PLATFORM_SETTINGS.SSONAME_AZURE] && platformSetting[PLATFORM_SETTINGS.SSONAME_AZURE].trim() !== "") {
      optsCopy.find(item => item.val === LOGIN_METHODS.AZURE).abbr = platformSetting[PLATFORM_SETTINGS.SSONAME_AZURE];
    }

    if (!optsCopy.find(item => item.selected)) {
      optsCopy.find(item => item.enabled).selected = true;
    }
    setLoginMethodOptions(optsCopy);
  }, [hostResource]);


  useEffect(() => {
    newPageLog("LoginPage.js");
  }, [])

  const validateForm = () => {
    let returnVal = true;
    if (!userName) {
      returnVal = false;
      setUserNameError(INVALID_USER_NAME_TEXT);
    } else {
      setUserNameError("");
    }

    if (!password) {
      returnVal = false;
      setPasswordError(INVALID_PWD_TEXT);
    } else {
      setPasswordError("");
    }
    return returnVal;
  };

  const onClickSignIn = () => {

    let signInBtn = document.getElementById("sign-in-button");
    if (signInBtn && signInBtn.getAttribute("data-disabled") === "true") {
      return;
    }

    if (loginMethodOptions[0].selected) {
      standaloneLogin();
    } else {
      loginViaSAML();
    }
  }

  const standaloneLogin = async () => {
    if (!validateForm()) {
      return;
    }
    setGuestSession({});
    try {
      setIsProcessing(true);
      await login({userName, password, keepSignIn}, (errorCode) => {
        if (errorCode === "Y022") {
          setUserNameError(INVALID_USER_NAME_TEXT);
        } else if (errorCode === "Y023") {
          setPasswordError(INVALID_PWD_TEXT);
        } else {
          notifyError(LOGIN_GENERAL_ERROR);
        }
      });
    } finally {
      setIsProcessing(false);
    }
  }

  const loginViaSAML = async() => {
    const selectedOpt = loginMethodOptions.find(opt => opt.selected);
    if (!selectedOpt) {
      return;
    }
    setIsProcessing(true);
    getSAMLRedirectURL(selectedOpt.key).then((redirectURL) => {
      if (!!redirectURL) {
        window.open(redirectURL, "_self");
      }
    }).finally(() => {
      setIsProcessing(false);
    });
  }

  const editUsername = (e) => {
    setUserName(e.target.value);
    setUserNameError("");
  }
  const editPassword = (e) => {
    setPassword(e.target.value);
    setPasswordError("");
  }

  const goReset = () => {
    history.push({ pathname: "/forgot" });
  }

  const togglePw = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await setPasswordShown(!passwordShown);
    const input = document.getElementById('input-pw');
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }


  return (
      <>
        <div
            style={{backgroundImage: !!imageURL ? `url(${imageURL})` : undefined}}
            className={!!imageURL ? styles.imageBackground : styles.gradientBackground}
        />
        <div className={`${styles.container} ${type === SCREEN_TYPE.MOBILE ? styles.mobileContainer : ""}`}>
          <div style={{flex: 1}}/>

          <div className={styles.loginCard}>
            <div className={styles.logoContainer}>
              {!!logoImageURL
                  ?
                  <div className={styles.logoImgWrapper}>
                    <img src={logoImageURL} alt={LOGIN_LOGO_TEXT} className={styles.logoImg}/>
                  </div>
                  :
                  <YuJaLogo/>
              }

              <span className={styles.mediumText}>
                {/*{fillFormatText(WELCOME_TO_PLATFORM_TEXT, {institutionName: institutionName})}*/}
                {WELCOME_TO_PLATFORM_TEXT}
              </span>
              <span className={styles.descriptionText}>{SIGN_IN_TO_YOUR_ACCOUNT_TEXT}</span>
            </div>


            <div style={{marginTop: 5}}>
              <span className={styles.labelText}>{SIGN_IN_OPTION_LABEL_TEXT}</span>
              <div style={{height: 10}}/>
              <YuJaDropdown
                  style={{padding: 12}}
                  size={YUJA_DROPDOWN_SIZE.LARGE}
                  data={loginMethodOptions.filter(item => item.enabled)}
                  getOptionValue={(item) => item.key}
                  getOptionLabel={(item) => item.abbr ? item.abbr : item.defaultName}
                  value={loginMethodOptions.find((item => item.selected))?.key}
                  onChange={(item) => {
                    let optsCopy = JSON.parse(JSON.stringify(loginMethodOptions));
                    optsCopy = optsCopy.map(item => ({...item, selected: false}));
                    optsCopy.find(i => i.key === item.key).selected = true
                    setLoginMethodOptions(optsCopy);
                  }}
                  placeholder={SIGN_IN_OPTION_LABEL_TEXT}
              />
            </div>
            {loginMethodOptions[0].selected &&
                <>
                  <div>
                    <div style={inlineStyles.rowStyle}>
                      <span className={styles.labelText}>{USERNAME}</span>
                      <span style={{flex: 1}}/>
                      {!!userNameError &&
                          <>
                            <INVALID_ICON/>
                            <span className={styles.errorText}>{userNameError}</span>
                          </>
                      }
                    </div>

                    <div style={{height: 10}}/>
                    <YuJaTextBox
                        containerStyle={inlineStyles.inputBoxStyle}
                        placeholder={ENTER_USERNAME_TEXT}
                        value={userName}
                        onChange={editUsername}
                        showTooltip={true}
                        onKeyUp={event => {
                          if (event.key === 'Enter') {
                            onClickSignIn();
                          }
                        }}
                        isInvalid={!!userNameError}
                        autoComplete="on"
                    />
                  </div>

                  <div>
                    <div style={inlineStyles.rowStyle}>
                      <span className={styles.labelText}>{PASSWORD}</span>
                      <span style={{flex: 1}}/>
                      {!!passwordError &&
                          <>
                            <INVALID_ICON/>
                            <span className={styles.errorText}>{passwordError}</span>
                          </>
                      }
                    </div>

                    <div style={{height: 10}}/>
                    <YuJaTextBox
                        showTooltip={true}
                        containerStyle={inlineStyles.inputBoxStyle}
                        type={passwordShown ? "text" : "password"}
                        placeholder={ENTER_PWD_TEXT}
                        value={password}
                        onChange={editPassword}
                        onKeyUp={event => {
                          if (event.key === 'Enter') {
                            onClickSignIn();
                          }
                        }}
                        isInvalid={!!passwordError}
                        autoComplete="on"
                        after={
                          <>
                            {!!password && (
                                <YuJaTooltip placement={"bottom"} text={SHOW_OR_HIDE_PWD_TEXT}>
                                  <img
                                      onClick={togglePw}
                                      className={styles.eye}
                                      src={passwordShown ? EyeOpen : EyeClosed}
                                      alt="eye"
                                      style={{cursor: "pointer"}}
                                  />
                                </YuJaTooltip>
                            )}
                          </>
                        }
                    />
                  </div>

                  <div style={inlineStyles.rowStyle}>
                    <YuJaCheckbox
                        label={REMEMBER_ME_TEXT}
                        size={18}
                        style={{fontSize: 15}}
                        onClick={e => setKeepSignIn(e.target.checked)}
                        checked={keepSignIn}
                        ariaLabel={REMEMBER_ME_ARIA_LABEL + " " + (keepSignIn ? CHECKED : UNCHECKED)}
                    />
                    <div style={{flex: 1}}/>
                    <YuJaTooltip text={FORGOT_PWD_TEXT + '?'} placement={"bottom"}>
                      <div
                          className={styles.linkText}
                          onClick={() => goReset()}
                          role={TEXTBOX}
                          aria-label={FORGOT_ARIA_LABEL}
                      >
                        {FORGOT_PWD_TEXT + '?'}
                      </div>
                    </YuJaTooltip>
                  </div>

                </>
            }

            <YuJaTooltip text={SIGN_IN_TEXT} placement={"bottom"}>
              <div
                  id={"sign-in-button"}
                  className={`${styles.signInButtonNew} ${isProcessing ? styles.loadingText : ""}`}
                  onClick={onClickSignIn}
                  data-disabled={!!isProcessing}
              >
                {SIGN_IN_TEXT}
              </div>
            </YuJaTooltip>

            <YuJaTooltip text={JOIN_AS_PARTICIPANT_TEXT} placement={"bottom"}>
              <div
                  className={styles.linkText}
                  onClick={() => history.push({pathname: JOIN_PARTICIPANT_PATH})}
                  role={TEXTBOX}
                  aria-label={FORGOT_ARIA_LABEL}
                  style={inlineStyles.linkStyle}
              >
                {JOIN_AS_PARTICIPANT_TEXT}
              </div>
            </YuJaTooltip>
          </div>
          <div style={{flex: 1}}/>
        </div>
      </>
  );
}
